import {
  GET_FABRIC_RESOURCE_SUCCESS,
  GET_FABRIC_RESOURCE_ERROR,
} from "./actionTypes"

const statuslist = {
  idle: "idle",
  process: "process",
  success: "success",
  error: "error",
}

const INIT_STATE = {
  data: {},
  error: {},
  status: statuslist.idle,
}

const FabricTradingCompanyResource = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_FABRIC_RESOURCE_SUCCESS:
      return {
        ...state,
        data: action.payload?.data,
        status: statuslist[action.payload.status],
      }
    case GET_FABRIC_RESOURCE_ERROR:
      return {
        ...state,
        data: {},
        error: action.payload?.data,
        status: statuslist.error,
      }
    default:
      return state
  }
}

export default FabricTradingCompanyResource
